export const isMobile: boolean = (navigator.platform.indexOf('iPhone') !== -1)
  || (navigator.platform.indexOf('iPad') !== -1)
  || (navigator.platform.indexOf('iPod') !== -1)
  || (navigator.userAgent.indexOf('Android') !== -1);
